export const SET_VALUE = 'SET_VALUE';
export const SET_TOUCHED = 'SET_TOUCHED';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_IS_SUBMITTING = 'SET_IS_SUBMITTING';
export const SET_ALL_TOUCHED = 'SET_ALL_TOUCHED';
export const SET_POSSIBLE_CARD_TYPE = 'SET_POSSIBLE_CARD_TYPE';
